//import 'bootstrap';
$(document).ready(() => {
  const hamb = document.querySelector("#hamb");
  const mainNav = document.querySelector("#main-nav");
  const overlay = document.querySelector("#overlay");
  const closeMenuBtn = document.querySelector("#close-menu");
  const searchBtn = document.querySelector("#search-btn");
  const closeSearchBtn = document.querySelector("#close-search-btn");
  const searchModal = document.querySelector("#search-modal");

  var dropdowns = document.querySelectorAll(".dropdown");
  var viewportWidth = $(window).width();

  // header scrll effect
  //hide header on scroll down
  let lastScroll = window?.pageYOffset || 0;
  function handleHeaderEffect() {
    if (viewportWidth <= 1023) {
      return;
    }
    let scrolly = window.pageYOffset;
    const hdr = document.querySelector("header");
    if (scrolly > 100) {
      hdr.classList.add("scrolled");
      if (window.pageYOffset > lastScroll) {
        hdr.style.transform = "translateY(-125%)";
      } else {
        hdr.style.transform = "translateY(0px)";
      }
    } else {
      hdr.classList.remove("scrolled");
      hdr.style.transform = "translateY(0px)";
    }

    // dropshadow
    // if (scrolly > 200) {
    //   hdr.classList.add("shadow");
    // } else {
    //   hdr.classList.remove("shadow");
    // }

    lastScroll = scrolly;
  }
  handleHeaderEffect();
  window.addEventListener("scroll", handleHeaderEffect);

  hamb.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      if (hamb.classList.contains("open")) {
        closeMenu();
      } else {
        openMenu();
      }
    },
    false
  );

  closeMenuBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeMenu();
    },
    false
  );

  searchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openSearch();
    },
    false
  );

  closeSearchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeSearch();
    },
    false
  );

  // opens the search
  function openSearch() {
    console.log("opensearch function");
    searchModal.classList.remove("hidden");
  }

  // closes the search
  function closeSearch() {
    searchModal.classList.add("hidden");
  }

  // opens main nav
  function openMenu() {
    //console.log("opening nav");
    mainNav.classList.add("open");
    hamb.classList.add("open");
    // overlay.classList.remove("hidden");
  }

  // closes main nav
  function closeMenu() {
    //console.log("closing nav");
    hamb.classList.remove("open");
    mainNav.classList.remove("open");
    closeAllDropDowns();
    // overlay.classList.add("hidden");
  }

  // animate on scroll library
  AOS.init();

  console.log(viewportWidth);

  $("body").click(function () {
    //closeSearch();
    closeAllDropDowns();
  });

  $(window).scroll(function () {
    if (viewportWidth <= 1023) {
      return;
    } else {
      closeSearch();
      closeAllDropDowns();
    }
  });

  // $('#searchHolderDesktop button').click(function (e) {
  //     e.stopPropagation()
  //     openSearch();
  // });

  // $('#searchHolderDesktop form').click(function (e) {
  //     e.stopPropagation()
  //     //openSearch();
  // });

  // function openSearch() {
  //     $('#searchHolderDesktop').addClass('active')
  //     $('#searchHolderDesktop form input.search-field').focus()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).addClass('hidden')
  //     })
  // }

  // function closeSearch() {
  //     $('#searchHolderDesktop').removeClass('active');
  //     $('#searchHolderDesktop form input.search-field').blur()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).removeClass('hidden')
  //     })
  // }

  function closeAllDropDowns() {
    $("header").removeClass("active");

    $(dropdowns).each(function () {
      $(this).removeClass("open");
      // Reset transform when closing
      $(this).find(".menu-mega-nav-container").css("transform", "");
    });
  }

  // on resize, reset this wiewport width
  window.addEventListener("resize", function () {
    closeAllDropDowns();
    closeMenu();
    viewportWidth = $(window).width();
    //console.log(viewportWidth);
  });

  $("header").mouseleave(function (e) {
    closeAllDropDowns();
  });


  $("header .dropdown.depth-0 > a").click(function (e) {
    if (viewportWidth > 1023) return;
    e.stopPropagation();

    console.log("click click");
    closeAllDropDowns();

    const $dropdown = $(this).parent();
    $dropdown.addClass("open");
    // Center the mega menu container on mobile as well
    centerMegaMenu($dropdown);
  });

  // clicking on "#" prevent jumping to top of page
  $("header nav a").click(function (e) {
    if ($(this).attr("href") == "#") {
      e.preventDefault();
      e.stopPropagation();
    }
  });


  // desktop mouseenter
  $("header .depth-0").mouseenter(function () {
    if (viewportWidth <= 1023) return;
    closeAllDropDowns();
    $("header").addClass("active");

    $(this).addClass("open");

    // Center the mega menu container relative to viewport
    centerMegaMenu($(this));
  });


  // second level menu items logic 
  $("header nav .depth-1.menu-item-has-children > a").click(function (e) {
    if (!$(this).parent().hasClass("open")) {
      e.preventDefault();
      e.stopPropagation();
      $(this).parent().addClass("open");
    }
  });


  // center the mega menu container relative to viewport
  function centerMegaMenu($dropdown) {
    const $menuContainer = $dropdown.find(".menu-mega-nav-container");
    if ($menuContainer.length === 0) return;

    const viewportWidth = window.innerWidth;
    const menuMaxWidth = 1440; // max-w-[1440px]
    const menuWidth = Math.min(viewportWidth, menuMaxWidth);

    // Get the parent dropdown's position relative to viewport
    const parentRect = $dropdown[0].getBoundingClientRect();
    const parentLeft = parentRect.left;

    // Calculate center position
    const viewportCenter = viewportWidth / 2;
    const menuCenter = menuWidth / 2;

    // Calculate the translateX needed to center in viewport
    // We need to account for the parent's left position since menu is positioned relative to parent
    const translateX = viewportCenter - parentLeft - menuCenter;

    // Apply the transform
    if (viewportWidth > 1023) {
      $menuContainer.css("transform", `translateX(${translateX}px)`);
    } else {
      $menuContainer.css("transform", `translateX(0px)`);
    }
  }
  // on load, fill h2 in menu-mega-nav-title with the title of the parent dropdown
  $("header .dropdown.depth-0.menu-item-has-children").each(function () {
    const $dropdown = $(this);
    const $menuTitle = $dropdown.find(".menu-mega-nav-title h2");
    $menuTitle.text($dropdown.find("a.main-item").text());
  });

  // Recalculate on window resize
  $(window).on("resize", function () {
    $("header .dropdown.depth-0.open").each(function () {
      centerMegaMenu($(this));
    });
  });
});
